"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIPage;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ComponentWithBodyClass = _interopRequireDefault(require("../utils/ComponentWithBodyClass"));

/**
 * Standard page container, setting classes, context, etc.
 */
function UIPage(props) {
  var bodyClassName = props.bodyClassName,
      bodyElement = props.bodyElement,
      className = props.className,
      TagName = props.tagName,
      rest = (0, _objectWithoutProperties2.default)(props, ["bodyClassName", "bodyElement", "className", "tagName"]);

  var renderedChildren = _react.default.createElement(TagName, Object.assign({}, rest, {
    className: (0, _classnames.default)(className, 'private-page')
  }));

  if (bodyClassName) {
    return _react.default.createElement(_ComponentWithBodyClass.default, {
      bodyClassName: bodyClassName,
      bodyElement: bodyElement
    }, renderedChildren);
  }

  return renderedChildren;
}

UIPage.propTypes = Object.assign({}, _ComponentWithBodyClass.default.propTypes, {
  bodyClassName: _propTypes.default.string,
  children: _propTypes.default.node.isRequired,
  tagName: _propTypes.default.string.isRequired
});
UIPage.defaultProps = Object.assign({}, _ComponentWithBodyClass.default.defaultProps, {
  tagName: 'div'
});
UIPage.displayName = 'UIPage';
module.exports = exports.default;